import React from 'react';

interface IInfoLabelHover {
    title: string,
    content: string
}

export default class InfoLabelHover extends React.Component<IInfoLabelHover> {
    public render() {
        const {content, title} = this.props;
        return (
            <div className="InfoLabelHover">
                {title + " "}      
                <i aria-hidden="true" className="fa fa-info-circle">
                    <div className="hoverContainer">
                        {content}
                    </div>
                </i>
            </div>
        )
    }
}